module.exports = __webpack_public_path__ + "94c00e196d18dced4b8f4bf9c8cc4c42.png";